/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseNumberField
 */
export interface DatabaseNumberField extends DatabaseField {
    /**
     * 
     * @type {number}
     * @memberof DatabaseNumberField
     */
    precision?: number;
    /**
     * STARTWERT FUER NEUE DATENSAETZE. Leer heisst: das Feld bleibt
     * leer, wie bisher.
     * 
     * WOFUER: Ueberall dort, wo ein Zaehler nicht bei nichts
     * anfaengt — die Bahn einer Scorecard beginnt bei 1, eine
     * Stueckzahl oft bei 1, ein Bestand bei 0. Ohne Startwert steht
     * dort ein leeres Feld, und der Bedienende muss raten, ob das
     * „null" oder „noch nichts" heisst.
     * 
     * Gesetzt wird er beim ANZEIGEN eines Feldes ohne Wert, nicht
     * beim Speichern — genauso wie beim Textfeld (`defaultTextValue`).
     * @type {number}
     * @memberof DatabaseNumberField
     */
    defaultValue?: number;
    /**
     * Kleinster zulaessiger Wert. Leer heisst: keine untere Grenze.
     * 
     * WOFUER: Ueberall dort, wo ein Wertebereich gilt und nicht nur
     * eine Zahl — Schulnoten 1 bis 6, Prozentwerte 0 bis 100,
     * Stueckzahlen ab 1, Schlaege beim Bahnengolf 0 bis 7. Ohne die
     * Grenze zaehlt der Stepper ins Unendliche, und eine Regel, die
     * nur in der Anleitung steht, halten Bedienende nicht ein.
     * @type {number}
     * @memberof DatabaseNumberField
     */
    minValue?: number;
    /**
     * Groesster zulaessiger Wert. Leer heisst: keine obere Grenze.
     * Liegt er unter `minValue`, wird er ignoriert — ein vertippter
     * Bereich soll die Eingabe nicht blockieren.
     * @type {number}
     * @memberof DatabaseNumberField
     */
    maxValue?: number;
    /**
     * Um wie viel die Pfeile den Wert aendern. Leer heisst 1, wie
     * bisher.
     * 
     * WOFUER (Prototyp des Betreibers, 07.10.2026): Beim Schaetzen
     * „wie viele Murmeln im Glas" zaehlen die Knoepfe in
     * Fuenferschritten — in Einerschritten waere der Weg von 128 auf
     * 300 unbedienbar. Null oder negativ wird ignoriert, sonst
     * stuende der Stepper still.
     * @type {number}
     * @memberof DatabaseNumberField
     */
    schrittweite?: number;
}

/**
 * Check if a given object implements the DatabaseNumberField interface.
 */
export function instanceOfDatabaseNumberField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseNumberFieldFromJSON(json: any): DatabaseNumberField {
    return DatabaseNumberFieldFromJSONTyped(json, false);
}

export function DatabaseNumberFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNumberField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'precision': !exists(json, 'precision') ? undefined : json['precision'],
        'defaultValue': !exists(json, 'defaultValue') ? undefined : json['defaultValue'],
        'minValue': !exists(json, 'minValue') ? undefined : json['minValue'],
        'maxValue': !exists(json, 'maxValue') ? undefined : json['maxValue'],
        'schrittweite': !exists(json, 'schrittweite') ? undefined : json['schrittweite'],
    };
}

export function DatabaseNumberFieldToJSON(value?: DatabaseNumberField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'precision': value.precision,
        'defaultValue': value.defaultValue,
        'minValue': value.minValue,
        'maxValue': value.maxValue,
        'schrittweite': value.schrittweite,
    };
}

